<template>
    <div class="fixed inset-x-0 bottom-0" v-if="!cookieBannerAccepted">
        <div class="bg-indigo-600">
            <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
                <div class="flex items-center justify-between flex-wrap">
                    <div class="w-0 flex-1 flex items-center">
            <span class="flex p-2 rounded-lg bg-indigo-800">
              <MegaphoneIcon class="h-6 w-6 text-white" aria-hidden="true" />
            </span>
                        <p class="ml-3 font-medium text-white truncate">
                            <span class="md:hidden"> {{translate('we_use_cookies_mobile')}}! <a href="/privacy" class="underline font-normal">{{translate('privacy_mobile')}}</a> </span>
                            <span class="hidden md:inline"> {{translate('we_use_cookies_desk')}}  <a href="/privacy" class="underline font-normal">{{translate('privacy_desk')}}</a></span>
                        </p>
                    </div>
                    <div class="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
                        <a href="#" class="flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium text-indigo-600 bg-white hover:bg-indigo-50" @click="setCookie()">
                            {{ translate('accept') }} </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { MegaphoneIcon } from '@heroicons/vue/24/outline'
import { useCookies } from "vue3-cookies";
import {ref} from "vue";
import translate from "../../lang";
import {usePage} from "@inertiajs/inertia-vue3";
export default {
    components: {
        MegaphoneIcon,
    },
    setup() {
        const { cookies } = useCookies();
        let cookieBannerAccepted = ref(cookies.get("w3r-cookiebanner") !== null);
        let setCookie = function() {
            this.cookies.set("w3r-cookiebanner", "true", "100d");
            cookieBannerAccepted.value = true;
        };
        return {
            setCookie,
            cookies,
            cookieBannerAccepted,
            translate: translate('global.cookies')
        }
    }
}
</script>
